export default __webpack_public_path__ + "static/media/bamidelee.2c4b9516.jpg";